import React from 'react';
import Helmet from 'react-helmet';
import { Config } from '../../config/index';
import AltadisSiteImage from '../../assets/images/home-altadis-image.png';
import eCommerceImage from '../../assets/images/home-ecommerce-image.png';
import CDMImage from '../../assets/images/home-cdm-image.png';
import { IBanner } from '../../definitions/home';
import { ComponentTheme } from '../../definitions/components';
import SubsidiarySite, { SubsidiarySiteAlignment } from '../../components/SubsidiarySite';
import { BannerSlider, BannerSlide } from './components/BannerSlider';
import { OurCompanies, BrandLogo } from './components/OurCompanies';
import LeadIn from '../../components/LeadIn/LeadIn';
import { AppContext } from '../../Context';
import { IRootState } from '../../definitions/root';

export default function HomeRender({ banners }) {
  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        const slidesToShow = isMobile || isTablet ? 2 : 5;
        return (
          <React.Fragment>
            <Helmet>
              <title>Home</title>
              <link rel="canonical" href={`${Config.FRONT_END_URL}`} />
              <meta name="description" content={'Home'} />
            </Helmet>

            <div className="page page--home">
              <BannerSlider
                renderCenterLeftControls={null}
                renderCenterRightControls={null}
                {...banners}>
                {banners.map((b: IBanner, i) => {
                  const isImage = !!this.isImageFile(b.banner);
                  const isVideo = !!this.isVideoFile(b.banner);
                  const banneerImageType = isMobile || isTablet ? b.banner_thumb : b.banner;
                  const bannerImage = !!isImage && !isVideo ? { backgroundImage: `url('${banneerImageType}')` } : undefined;
                  const bannerVideo = !isImage && !!isVideo && b.banner;
                  return (
                    <BannerSlide
                      key={i}
                      bannerImage={bannerImage}
                      bannerVideo={bannerVideo}
                      title={b.title}
                      description={b.description}
                      buttonUrl={b.button_url}
                    />
                  );
                })}
              </BannerSlider>

              <OurCompanies
                slidesToShow={slidesToShow}
                renderCenterLeftControls={({ previousSlide }) => (
                  <button className="btn btn-prev-slide" onClick={previousSlide}>
                    <i className="icn icon-ios-arrow-back" />
                  </button>
                )}
                renderCenterRightControls={({ nextSlide }) => (
                  <button className="btn btn-next-slide" onClick={nextSlide}>
                    <i className="icn icon-ios-arrow-forward" />
                  </button>
                )}
                renderBottomCenterControls={null}>
                {this.subsidiaryBrandLogos
                  .map((brandLogo) => {
                    return (
                      <BrandLogo
                        key={brandLogo.name}
                        name={brandLogo.name}
                        logo={brandLogo.logo}
                        url={brandLogo.url} />
                    );
                  })}
              </OurCompanies>

              <LeadIn
                title='Tabacalera USA'
                subtitle='Leading the U.S. Premium Cigar Market' />

              <SubsidiarySite
                name="Altadis U.S.A."
                info="Market leader with top-selling and most recognizable brands in the U.S. including: Montecristo, Romeo y Julieta, H. Upmann, Casa de Garcia and others."
                link="/our-companies/altadis-usa"
                image={AltadisSiteImage}
              />

              <SubsidiarySite
                name="JR Cigars"
                info="The largest online retailer for premium cigars, cigar accessories, humidors and more in the U.S."
                link="/our-companies/jr-cigars"
                image={eCommerceImage}
                theme={ComponentTheme.DARK_TRANSPARENT}
                alignment={SubsidiarySiteAlignment.LEFT}
                btnTheme={ComponentTheme.LIGHT_TRANSPARENT}
                bgImage={require('../../assets/images/cigars-bg.jpg')}>
                <img
                  style={{ marginTop: '20px', display: 'block' }}
                  src={require('../../assets/images/home-ecommerce-logos.png')}
                  alt="Tabacalera eCommerce site logos"
                />
              </SubsidiarySite>

              <SubsidiarySite
                name="Casa de Montecristo"
                info="Casa de Montecristo is a premier modern cigar store featuring a large selection of premium cigars, smoking accessories, walk-in humidors, lounges and full bars across the U.S. We are reinventing the premium cigar experience."
                link="/our-companies/casa-de-montecristo"
                image={CDMImage}
              />
            </div>
          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home/render.tsx